import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isEqual as _isEqual, isEmpty as _isEmpty } from 'lodash';

/**
 * WARNING: if the controlToMatchValues field changes value, then this validator won't be triggered.
 *
 * For example: lets say you have a password field and a confirmPassword field. The desired outcome is that
 * when the password field and the confirmPassword field don't match, then the validator is supposed to report
 * that the fields don't match and fail the validation rule. Now let's say you first type the password field in
 * and then you type the EXACT same thing into the confirmPassword field. So the two are matching and the
 * validation passes. Ok great, that is desired. But now what if you go back up to the password field and
 * change the password? Well since the confirmPassword field value didn't change (only the password field
 * changed), it doesn't trigger this Validation rule to run. So even though the password field and the
 * confirmPassword field are now different, the validation check on confirmPassword didn't trigger
 * and so the confirmPassword control's status is VALID and overall form status is also VALID even though
 * it should be "INVALID". So what you need to do is subscribe to value changes on the password form control
 * and on value change, you need to call the `updateValueAndValidity()` method on the confirmPassword control
 * that will cause it to run the validation rule again when the password control value changes and then
 * when the password field changes to be different from the confirmPassword field it will report the
 * validation error and the confirmPassword control's status will change to INVALID and the overall form's
 * status will also change to INVALID.
 * 
 * @param controlToMatchValues 
 * @param sitefinityContentKeyForFailedValidationMessage 
 * @returns 
 */
export function buildMatchFieldValidator(controlToMatchValues: AbstractControl, sitefinityContentKeyForFailedValidationMessage: string ): ValidatorFn {
  if (controlToMatchValues == null) {
    throw new Error("controlToMatchValues argument cannot be null");
  }
  if (_isEmpty(sitefinityContentKeyForFailedValidationMessage)) {
    throw new Error("sitefinityContentKeyForFailedValidationMessage must be a non-empty string");
  }
  
  return (control: AbstractControl) => {
    return _isEqual(control?.value, controlToMatchValues?.value) ? null : { matchField: sitefinityContentKeyForFailedValidationMessage };
  };
}